import type { HubFaq, HubSection } from "@/components/HubEditorial";

/* ---------------------------------- /fritid --------------------------------- */

export const fritidSections: HubSection[] = [
  {
    h2: "Förtält & markiser i norrbottniskt väder",
    paragraphs: [
      "Ett förtält som fungerar i Skåne kan vara fel val i Kalix. Vi väljer sortiment efter vind och snölast: kraftigare stänger, dubbelsömmar och tyg som klarar UV under midnattssol men också fukt i september. En markis på 3,5 meter räcker för de flesta husbilar upp till 7 meter, men vid fast uppställning på ställplats vinner ett fristående förtält eftersom du kan lämna det uppe.",
      "Tänk igenom hur ofta du flyttar dig. Reser du vidare varannan dag är vikt och restid viktigare än utrymme — då är en solskärm på 2–3 kg bättre än ett förtält på 18 kg som tar 40 minuter att resa.",
    ],
    bullets: [
      "Vindstabilt: stormband i alla fyra hörn, aldrig bara två.",
      "Snölast: fäll ihop markisen även vid lätt snö — motorns växel tar skada först.",
      "Fukt: torka tältduken innan förvaring, annars är mögel ett faktum till våren.",
    ],
  },
  {
    h2: "El & energi — så räknar du ut ditt behov",
    paragraphs: [
      "Räkna i wattimmar, inte i känsla. Kylskåp på 12 V drar 300–600 Wh per dygn, belysning 50–100 Wh, vattenpump 20 Wh, laddning av telefon och dator 100–200 Wh. Ett normalt fritidsdygn hamnar på 500–900 Wh. Ett AGM-batteri på 100 Ah ger cirka 600 Wh användbart (halva kapaciteten), ett litiumbatteri på 100 Ah ger cirka 1 200 Wh.",
      "Solpaneler i Norrbotten producerar mycket från april till augusti och nästan inget i december. 200 W panel täcker sommarbruket, men vintercamping kräver landström eller laddning via motorn med en DC-DC-laddare (B2B).",
    ],
    bullets: [
      "Har du litium behöver du en laddare som klarar litiumprofil — en gammal blysyra-laddare underladdar.",
      "Mät med shuntbaserad batterimätare, inte spänningsmätare — spänning ljuger under last.",
      "Kontrollera säkringar och kabelareor innan du bygger ut; för klen kabel är den vanligaste bakomliggande orsaken till spänningsfall.",
    ],
  },
  {
    h2: "Kök, gasol och säker installation",
    paragraphs: [
      "Gasol är fortfarande det effektivaste sättet att laga mat och värma i en husbil, men installationen ska vara rätt. Slangar har utgångsdatum, regulatorn ska sitta med krockskydd i fordon och tuben ska stå upprätt och surrad. Alla fordon vi levererar är gasoltestade vid leverans — det ingår, du behöver inte begära det.",
      "Vill du minska gasolberoendet är en induktionsplatta på 1 800 W möjlig med landström, men i praktiken orealistisk på batteri om du inte har litium och växelriktare på minst 2 000 W.",
    ],
    bullets: [
      "Byt gasolslang enligt datummärkning, normalt vart femte till åttonde år.",
      "Ha alltid en gasolvarnare i låg position — gasol är tyngre än luft och lägger sig i golvet.",
      "Två 6 kg-tuber är oftast smartare än en 11 kg: du får reserv och lättare lyft.",
    ],
  },
  {
    h2: "Förvaring, säkerhet och komfort",
    paragraphs: [
      "Vikt är den dolda kostnaden. Många husbilar har bara 300–500 kg lastkapacitet, och full färskvattentank, två personer, cyklar och grill äter upp det snabbt. Väg fordonet lastat på en allmän våg innan sommarresan — överlast är både böter och sämre bromsverkan.",
      "På säkerhetssidan är fukt den enskilt största riskfaktorn för ekonomin. Vi fukttestar varje fordon vid leverans och rekommenderar egen kontroll varje höst i takfönsterkarmar, i hörnen bakom garderoben och längs golvvinkeln.",
    ],
    bullets: [
      "Rattlås eller hjulklo syns och avskräcker mer än enbart larm.",
      "Använd låg tyngdpunkt: tunga saker i golvnära förvaring, aldrig i takskåp.",
      "Avfuktare i vinterförvaring håller textilier och trä friska utan uppvärmning.",
    ],
  },
];

export const fritidFaq: HubFaq[] = [
  {
    q: "Kan jag beställa tillbehör som inte finns i sortimentet?",
    a: "Ja. Ring eller mejla oss med modell och årsmodell — vi tar hem det mesta inom husbil och husvagn och kan oftast leverera inom några arbetsdagar.",
  },
  {
    q: "Hjälper ni med montering av markis och solpanel?",
    a: "Vi monterar tillbehör i samband med försäljning och service i Kalix. Boka tid i förväg, det är oftast ett halvdagsjobb per markis eller solcellspaket.",
  },
  {
    q: "Vilket batteri ska jag välja — AGM eller litium?",
    a: "AGM om du mest står på landström och reser sommartid. Litium om du frilufts-campar, behöver snabb laddning från motorn eller vill driva större förbrukare. Litium kostar mer men ger dubbelt så mycket användbar energi per kilo.",
  },
  {
    q: "Ingår fukt- och gasoltest när jag köper fordon av er?",
    a: "Ja, alla fordon vi levererar är fukttestade och gasoltestade vid leverans. Du får resultatet vid överlämning.",
  },
  {
    q: "Var köper jag tillbehören?",
    a: "Vi säljer i butiken i Kalix och via vår butik på Fyndanu.se. Är du osäker på vad som passar din modell, hör av dig först — det sparar en returfrakt.",
  },
];

/* --------------------------------- /guider --------------------------------- */

export const guiderSections: HubSection[] = [
  {
    h2: "Varför vi skriver guiderna själva",
    paragraphs: [
      "Guiderna bygger på det vi ser i verkstaden och vid inbyten, inte på hopsamlad text från andra sajter. När vi skriver att fukt oftast startar vid takfönstrets bakkant är det för att det är där vi hittar den, gång på gång, i fordon som kommer in för värdering.",
      "Varje guide är skriven för att kunna läsas färdig innan du fattar ett beslut: vilket körkort du behöver, hur du vinterförvarar utan skador, och vad du faktiskt ska kontrollera innan du skriver på ett köpekontrakt.",
    ],
  },
  {
    h2: "Var ska du börja?",
    paragraphs: [
      "Är du ny på husbil börjar du med körkortsguiden — den avgör vilka fordon som ens är möjliga för dig. Har du redan fordon och närmar dig oktober är vinterförvaringen viktigast; de flesta dyra skador uppstår under de månader fordonet står still.",
      "Ska du köpa begagnat inom kort läser du köp-checklistan och tar med den utskriven. Punkterna är sorterade efter vad som kostar mest att åtgärda i efterhand.",
    ],
    bullets: [
      "Ny på husbil: körkort → köp-checklista → vinterförvaring.",
      "Byter upp dig: köp-checklista → vår fordonslista → värdering av ditt nuvarande fordon.",
      "Erfaren: vinterförvaring och underhåll, plus diskussionerna i Fritidsforum.",
    ],
  },
  {
    h2: "Säsongskalender för husbilsägare",
    paragraphs: [
      "Fritidsfordon i norra Sverige har en tydlig årscykel. Följer du den slipper du de flesta akuta verkstadsbesöken.",
    ],
    bullets: [
      "Mars–april: avvintring, batterikontroll, tätningskontroll efter snösmältning.",
      "Maj–juni: service, däckåldern kontrolleras (över 6 år bytes oavsett mönster), gasoltest.",
      "Juli–augusti: högsäsong — kontrollera lastvikt och däcktryck före varje längre resa.",
      "September–oktober: fukttest, avvattning, avfuktare in, förvaring på plats som inte samlar snö mot väggarna.",
      "November–februari: kontrollera fordonet var tredje vecka om det står ute, framför allt taket.",
    ],
  },
  {
    h2: "Guider, forum och lager hänger samman",
    paragraphs: [
      "Guiderna svarar på hur, forumet svarar på vad andra faktiskt upplevde, och fordonslistan visar vad som finns här och nu. Har du en fråga som ingen guide täcker är forumet rätt plats — vi svarar själva där, och andra ägare fyller på med erfarenhet från samma modell.",
      "Vill du sälja i stället för att köpa hittar du vår marknadsplats på Fyndanu.se, där annonsen når köpare i hela landet.",
    ],
  },
];

export const guiderFaq: HubFaq[] = [
  {
    q: "Vilket körkort behöver jag för husbil?",
    a: "B-körkort räcker upp till 3 500 kg totalvikt. Över det behöver du C1 (upp till 7 500 kg) eller C. B96 och BE gäller släpvagnskombinationer, inte tyngre husbilar. Vår körkortsguide går igenom gränserna i detalj.",
  },
  {
    q: "Hur ofta bör jag fukttesta?",
    a: "En gång per år, helst på hösten innan förvaring, samt alltid före ett köp. Värden under 15 procent är normalt, 15–20 kräver bevakning och över 20 procent innebär att du ska åtgärda direkt.",
  },
  {
    q: "Är det farligt att köpa husbil på vintern?",
    a: "Nej, tvärtom — priserna är lägre november till februari. Men du ser mindre vid en visning i mörker och snö, så be om fukttestprotokoll och bilder från sommaren, och gör provkörning på torr väg.",
  },
  {
    q: "Kan jag ställa frågor direkt till er?",
    a: "Ja. Ring butiken i Kalix, mejla via kontaktsidan eller skriv i Fritidsforum. Vi svarar oftast samma dag på vardagar.",
  },
];

/* ------------------------------ /campingtips ------------------------------- */

export const campingSections: HubSection[] = [
  {
    h2: "Ställplats, camping eller naturnära — vad skiljer?",
    paragraphs: [
      "En ställplats är en yta avsedd för husbilar med tömning och ofta vatten, men sällan servicehus. En camping har el, dusch, tvätt och plats för förtält, och tar högre avgift. Naturnära uppställning enligt allemansrätten är tillåten ett dygn där markägaren inte förbjudit det, men gäller inte i naturreservat, på åkermark eller på privata gårdsplaner.",
      "I Norrbotten är avstånden mellan servicepunkter längre än i södra Sverige. Planera tömning och vatten var tredje dygn snarare än varje kväll, och räkna med att flera platser stänger sitt vatten redan i september på grund av frost.",
    ],
    bullets: [
      "Ställplats: billigast, snabbast, sämst service.",
      "Camping: bäst för familj, tvätt och längre stopp.",
      "Naturnära: ett dygn, ingen tömning, lämna platsen renare än du kom.",
    ],
  },
  {
    h2: "Så skriver du ett tips som andra faktiskt använder",
    paragraphs: [
      "De bästa tipsen här innehåller det som inte står på skyltarna: om marken lutar, om det går att vända med 8 meter, om mobiltäckningen räcker till jobb, och hur nära vägen ligger när du ska sova.",
    ],
    bullets: [
      "Ange fordonslängd du själv stod med — lutning och vändradie är fordonsberoende.",
      "Skriv vad som fanns: el, vatten, tömning, sopor, dusch, betalning (Swish eller app).",
      "Nämn säsong. Samma plats kan vara perfekt i juli och avstängd i oktober.",
      "Ta bilder som visar underlaget och infarten, inte bara utsikten.",
    ],
  },
  {
    h2: "Så bedömer du om platsen passar ditt ekipage",
    paragraphs: [
      "Börja med infarten, underlaget och möjligheten att vända — inte utsikten. En plats kan vara enkel för en sexmeters plåtis men olämplig för en åttameters husbil med långt överhäng. Kontrollera också om servicepunkten går att nå utan att blockera utfarten.",
      "Uppgifter märkta som kontrollerade är avstämda mot angiven källa vid datumet som visas. Erfarenhetsuppgifter beskriver ett faktiskt besök, men pris, öppettider, väglag och lokala regler kan ändå ha ändrats.",
    ],
    bullets: [
      "Infart: kontrollera bredd, höjd, backning och vändmöjlighet.",
      "Övernattning: jämför lutning, nattro, belysning och mobiltäckning.",
      "Service: skilj på färskvatten, gråvatten och latrintömning.",
      "Före avresa: bekräfta dagspris, säsong och bokningsregler hos platsen.",
    ],
  },
];

export const campingFaq: HubFaq[] = [
  {
    q: "Får jag stå över natten på en parkering med husbilen?",
    a: "Att parkera enligt gällande parkeringsregler är tillåtet, men att campa — ställa ut stolar, markis eller stödben — är det oftast inte. Kontrollera lokala föreskrifter och skyltning.",
  },
  {
    q: "Hur hittar jag tömning i Norrbotten?",
    a: "Större campingar, flera ställplatser och vissa bensinstationer har latrintömning. Räkna med längre avstånd än i södra Sverige och töm när du har chansen, inte när du måste.",
  },
  {
    q: "Kan jag lägga upp tips utan konto?",
    a: "Nej, du behöver ett gratiskonto — det håller kvaliteten uppe och gör att andra kan ställa följdfrågor till dig i kommentarerna.",
  },
  {
    q: "Hur vet jag om informationen fortfarande gäller?",
    a: "Se tipsets besöksdatum, kontrollstatus och källor. Pris, öppettider, väglag och lokala regler kan ändras snabbt, så bekräfta alltid föränderliga uppgifter med platsen före avresa.",
  },
];

/* --------------------------------- /kontakt -------------------------------- */

export const kontaktSections: HubSection[] = [
  {
    h2: "Så hittar du hit",
    paragraphs: [
      "Vi finns på Stabsvägen 5 i Kalix, cirka tio minuter från E4 och ungefär en timme från Luleå. Anläggningen har gott om plats att vända med långa fordon och släp, så du kan komma hit med din nuvarande husbil eller husvagn för värdering utan att behöva parkera på gatan.",
      "Kommer du längre bort ifrån — Boden, Piteå, Haparanda eller Umeå — ring innan du åker så vi har fordonet du vill se framkört och avlåst.",
    ],
    bullets: [
      "Adress: Stabsvägen 5, Kalix.",
      "Telefon: 070-862 97 43 (Aaron).",
      "Bokad visning går alltid före drop-in, även utanför ordinarie tid.",
    ],
  },
  {
    h2: "Vad vi hjälper till med",
    paragraphs: [
      "Vi säljer husbilar och husvagnar, tar inbyten, förmedlar finansiering och levererar varje fordon fukttestat och gasoltestat. Vi säljer också tillbehör och tar hem reservdelar, även till fordon vi inte sålt.",
      "Är du osäker på vad ditt nuvarande fordon är värt får du en värdering utan att du binder dig till något. Vi tittar på fukt, chassi, mätarställning, servicehistorik och vad liknande fordon faktiskt säljs för — inte vad de annonseras för.",
    ],
    bullets: [
      "Köp, inbyte och förmedling av husbil och husvagn.",
      "Fukttest och gasoltest ingår vid leverans.",
      "Finansiering med besked oftast samma dag.",
      "Tillbehör och reservdelar, även till äldre modeller.",
    ],
  },
  {
    h2: "Så snabbt svarar vi",
    paragraphs: [
      "Formuläret här går direkt till oss och besvaras normalt inom 24 timmar på vardagar. Har du brådskande fråga om ett specifikt fordon är telefon snabbast — det händer att samma fordon har flera intressenter samma dag.",
      "Skriv gärna fordonets namn eller länk i meddelandet, plus när du har möjlighet att komma på visning. Då kan vi svara med tider direkt i stället för att mejla fram och tillbaka.",
    ],
  },
];

export const kontaktFaq: HubFaq[] = [
  {
    q: "Kan jag komma på visning utan att boka?",
    a: "Ja, men ring gärna först. Vi är ofta ute på leverans eller hämtning, och med ett samtal i förväg står fordonet klart när du kommer.",
  },
  {
    q: "Tar ni inbyte?",
    a: "Ja, vi tar in husbilar och husvagnar i inbyte och gör en kostnadsfri värdering. Ta med servicehistorik om du har den, det påverkar värdet.",
  },
  {
    q: "Ordnar ni finansiering?",
    a: "Ja, vi förmedlar finansiering via etablerade långivare och får oftast besked samma dag. Kontantinsats brukar ligga på 20 procent.",
  },
  {
    q: "Levererar ni fordon utanför Norrbotten?",
    a: "Det går att ordna transport mot kostnad. Hör av dig med ort så räknar vi på det.",
  },
];
